import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import IconEstado from "../UI/IconEstado";

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
    backgroundColor: "lightblue",
  },
});

export const AutorizacionesConsumoMaterial = (props) => {
  const classes = useRowStyles();

  const { material } = props;

  return (
    <>
      <TableRow className={classes.root}>
        <TableCell component="th" scope="row">
            <IconEstado
                useColorTable={true}
                texto={material?.estadoMaterial?.letra}
                backgroundColor={material?.estadoMaterial?.color}
                descripcion={material?.estadoMaterial?.descripcion}
            />
        </TableCell>
        <TableCell component="th" scope="row">
          {material?.material?.descripcion}
        </TableCell>
        <TableCell align="right">{material?.cantidad}</TableCell>
      </TableRow>
    </>
  );
};
